<template>
  <div>
    <!-- 视频资讯推荐 -->
    <AtricleVideoRecommend class="mb-8" :recommendList="recommendList" v-if="recommendList.length"/>
    <TodayHotList class="mb-8" />
    <HotSearchList class="mb-8" />
    <!-- <nuxt-link v-if="settledBanner.image" class="block shadow transition-shadow mt-6 hover:shadow-lg"
      :to="settledBanner.to">
      <el-image class="block" :src="settledBanner.image" />
    </nuxt-link> -->
    <DiscountedGoodsCard v-for="(product, index) in productList?.data" :key="product.product_no" :product="product"
      :rank="index + 1" class="mb-[12px]" :isShow="false" @onToggleFavorite="onToggleFavorite" />
    <PlatformAdvertStairSwiper :items="adBanner.state" v-if="type" />

  </div>
</template>
<script>
import { ref, onBeforeMount } from "@nuxtjs/composition-api";
import TodayHotList from "@/views/company/TodayHotList.vue";
import HotSearchList from "@/views/company/HotSearchList.vue";
import PlatformAdvertStairSwiper from "@/components/product/PlatformAdvertStairSwiper.vue";
import DiscountedGoodsCard from '@/views/Search/DiscountedGoodsCard.vue';

import usePlatformAdvertBanner from '@/composables/usePlatformAdvertBanner';
import usePlatformAdvertStairStore from '@/composables/usePlatformAdvertStairStore';
import useRequest from "@/composables/useRequest";
import useMessage from "~/composables/useMessage";

import { getArticleDetail } from "@/services/company";
import { addFavorites, cancelFavorites } from "~/services/product";
import { REQUEST_CODES } from "@/constants/const-http.js";
import AtricleVideoRecommend from './AtricleVideoRecommend.vue'
export default {
  components: {
    TodayHotList,
    HotSearchList,
    DiscountedGoodsCard,
    PlatformAdvertStairSwiper,
    AtricleVideoRecommend,
  },
  props: {
    type: String | Number,
    articleId: String,
    recommendList:{
      type:Array,
      default:[]
    },
    relationData: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const $message = useMessage();
    const productList = ref([]);

    const adBanner = ref(usePlatformAdvertBanner(props.type));
    const adStore = usePlatformAdvertStairStore('web_search_right');

    const { state, execute } = useRequest(
      () =>
        getArticleDetail({
          no: props.articleId
        }),
      {
        title: "",
        author_info: {},
        content: "",
        voice: "",
        relation: []
      },
      {
        immediate: false
      }
    );

    onBeforeMount(async () => {
      // await execute(0);
      productList.value = props.relationData.find(item => item.template === 'product')
    });

    const onToggleFavorite = async (is_favorite, product_no) => { //收藏/取消收藏
      if (is_favorite) {
        const { code, msg } = await cancelFavorites(
          product_no
        );
        if (code !== REQUEST_CODES.ERROR_OK) {
          $message.error(msg);
          throw new Error(msg);
        }
        $message.success("取消收藏成功");
      } else {
        const { code, msg } = await addFavorites(
          product_no
        );
        if (code !== REQUEST_CODES.ERROR_OK) {
          $message.error(msg);
          throw new Error(msg);
        }
        $message.success("收藏成功");
      }
    };

    return { adBanner, adStore, productList, onToggleFavorite };
  },
};
</script>
<style lang="">


</style>